import swal from "sweetalert2";
export default {
    ErrorAlert: function ErrorAlert(message){
        new swal({
            position: 'top-start',
            icon: 'error',
            title: message,
            timer: 3000,
            showConfirmButton: true,
        });
    },

    SuccessAlert: function SuccessAlert(message){
        new swal({
            position: 'top-start',
            icon: 'success',
            showConfirmButton: false,
            title: message,
            timer: 1000
        });
    }
}
